import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class SharedService {
  UploadedFileData: Subject<any> = new Subject<any>();
  CreateFileData: Subject<any> = new Subject<any>();
  constructor() { }
}
